import React from 'react';
import { useNavigate } from 'react-router-dom';
import FilterSelect from './FilterSelect';
import { useGradeSyncPath } from './gradeSyncPath';

/** Find a teacher by name, email or staffer id, and open their grade sync page. */
const TeacherSearch = () => {
  const navigate = useNavigate();
  const gradeSyncPath = useGradeSyncPath();

  return (
    <div className="tw-mb-5 tw-max-w-xl">
      <label className="tw-mb-1 tw-block tw-text-xs tw-text-spa-secondary" htmlFor="grade-sync-teacher-search">
        Find a teacher
      </label>
      <FilterSelect
        inputId="grade-sync-teacher-search"
        kind="staffer"
        placeholder="Name, email or staffer ID"
        scope={{}}
        value=""
        onChange={(id) => {
          if (id !== '') navigate(gradeSyncPath(`/teachers/${id}`));
        }}
      />
    </div>
  );
};

export default TeacherSearch;
